import { format } from 'date-fns';
import { jsPDF } from 'jspdf';

const TAMANHO_FONTE = 8;
const DISTANCIA_DA_BORDA = 8;

/**
 * Escreve "Página X de Y | Relatório impresso em … | JurisNet 2.0" centralizado
 * no rodapé de todas as páginas. Chamar depois de montar o documento inteiro —
 * é o que permite saber o total real e medir o texto que será de fato impresso.
 */
export function escreverRodape(doc: jsPDF): void {
    const total = doc.getNumberOfPages();
    const { pageSize } = doc.internal;
    const largura = pageSize.width ?? pageSize.getWidth();
    const altura = pageSize.height ?? pageSize.getHeight();

    const impressoEm = format(new Date(), "dd/MM/yyyy 'às' HH:mm:ss'.'");

    for (let pagina = 1; pagina <= total; pagina += 1) {
        doc.setPage(pagina);
        doc.setFontSize(TAMANHO_FONTE);

        const texto =
            `Página ${pagina} de ${total} | ` +
            `Relatório impresso em ${impressoEm} | JurisNet 2.0`;

        const x = (largura - doc.getTextWidth(texto)) / 2;

        doc.text(texto, x, altura - DISTANCIA_DA_BORDA);
    }
}

export default escreverRodape;
